import { WIDGET_COMPONENT } from '@app/shared/types';
import { I18n } from '../strings-keys';

export const XuxDatePickerStaticTextContent = Object.freeze({
  xuxDatepickerInput: Object.freeze({
    period: I18n.Common.Period,
    previousPeriod: I18n.Common.PreviousPeriod,
    currentPeriod: I18n.Common.CurrentPeriod,
    xuxDatepicker: {
      selectDate: I18n.Common.SelectDate,
      date: I18n.Common.Date,
      cancel: I18n.Common.Cancel,
      apply: I18n.Common.Apply,
      xuxDatepickerRange: {
        selectFrom: I18n.Common.SelectFrom,
        selectTo: I18n.Common.SelectTo,
        from: I18n.Common.From,
        to: I18n.Common.To,
      },
    },
  }),
});

export const XuxDateTimePickerStaticTextContent = Object.freeze({
  xuxTimePicker: {
    timePickerModal: {
      cancel: I18n.Common.Cancel,
      clear: I18n.Common.Clear,
      apply: I18n.Common.Apply,
    },
  },
});

export const XuxInputCheckboxGroupStaticTextContent = Object.freeze({
  selectAll: I18n.Common.SelectAll,
  deselectAll: I18n.Common.DeselectAll,
});

export const FORM_WIDGET_STATIC_TEXT_CONTENT = Object.freeze({
  // Define your static text content for form widgets here
  [WIDGET_COMPONENT.xux_datepicker]: XuxDatePickerStaticTextContent,
  [WIDGET_COMPONENT.checkbox_group]: XuxInputCheckboxGroupStaticTextContent,
});
